import { useCallback } from 'react';

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const validate = (cred) => {
  const errors = {};
  const ref = cred?.data?.reference;

  if (!ref?.contact_email) {
    errors.contact_email = 'Contact email is required';
  } else if (!isValidEmail(ref.contact_email)) {
    errors.contact_email = 'Please enter a valid email address';
  }

  return errors;
};

const hasFieldChanged = (current, original, field) =>
  (current?.data?.reference?.[field] ?? '') !== (original?.data?.reference?.[field] ?? '');

export const useCredentialReference = () => {
  const getErrors = useCallback((current, original) => {
    const allErrors = validate(current);
    const visibleErrors = {};
    Object.entries(allErrors).forEach(([field, message]) => {
      if (hasFieldChanged(current, original, field)) {
        visibleErrors[field] = message;
      }
    });
    return visibleErrors;
  }, []);

  const validateAll = useCallback((credentials) => {
    const allErrors = {};

    credentials.forEach((cred) => {
      const credErrors = validate(cred);
      if (Object.keys(credErrors).length > 0) {
        allErrors[cred.id || cred.credential] = credErrors;
      }
    });

    return allErrors;
  }, []);

  return { getErrors, validateAll };
};
